import { UpsellStatusType } from '@modules/husleie-framework/src/types/Upsell.entity';
import { UpsellDepositAccount } from '@modules/husleie-framework/src/types/UpsellDepositAccount.entity';
import { UpsellKYC } from '@modules/husleie-framework/src/types/UpsellKYC.entity';
import UpsellDepositAccountState from '@modules/store/upsell/types/UpsellDepositAccountState.entity';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<UpsellDepositAccountState> = {
  setUpsellDepositAccountLoading: (state: UpsellDepositAccountState, payload: boolean) => {
    state.loading = payload;
  },
  setUpsellDepositAccountLoaded: (state: UpsellDepositAccountState, payload: boolean) => {
    state.loaded = payload;
  },
  setUpsellDepositAccountApiError: (state: UpsellDepositAccountState, payload: boolean) => {
    state.apiError = payload;
  },
  setUpsellDepositAccount: (state: UpsellDepositAccountState, payload: UpsellDepositAccount) => {
    state.upsell.depositAccount = { ...state.upsell.depositAccount, ...payload };
  },
  setUpsellDepositAccountUuid: (state: UpsellDepositAccountState, payload: string) => {
    state.upsell.depositAccount.uuid = payload;
  },
  setUpsellDepositAccountStatus: (state: UpsellDepositAccountState, payload: UpsellStatusType) => {
    state.upsell.depositAccount.status = payload;
  },
  setUpsellDepositAccountKYC: (state: UpsellDepositAccountState, payload: UpsellKYC) => {
    state.upsell.depositAccount.kyc = payload;
  },
  setUpsellDepositAccountSigningURL: (state: UpsellDepositAccountState, payload: string) => {
    state.upsell.depositAccount.signing = state.upsell.depositAccount.signing
      ? { ...state.upsell.depositAccount.signing, url: payload }
      : { url: payload };
  },
  setUpsellDepositAccountRedirectURL: (state: UpsellDepositAccountState, payload: string) => {
    state.upsell.depositAccount.redirect = state.upsell.depositAccount.redirect
      ? { ...state.upsell.depositAccount.redirect, url: payload }
      : { url: payload };
  },
};
